import API from '../index';
import { PaymentMethod } from '../../types/payment';

const filterPaymentMethods = (methods: PaymentMethod[]) =>
  methods.filter((method) => method.enable && method.platforms.web);

const getPaymentMethods = async (): Promise<PaymentMethod[]> => {
  const { resources } = await API.get('/customer/methods');
  return filterPaymentMethods(resources);
};

export default getPaymentMethods;
